import { useEffect, useRef } from "react";
import { useBlocks } from "@/hooks/useContent";

const FALLBACK = "Thank you for telling us. Our care team has been notified, but this app is not monitored 24 hours a day. If you are in danger or thinking about suicide, call or text 988 now, or call 911.";

export const SafetyMessage = ({ lines = [], onDismiss }) => {
  const { data: blocks } = useBlocks();
  const btn = useRef(null);
  useEffect(() => { btn.current?.focus(); }, []);
  const block = blocks?.["safety.message"];
  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto bg-olive-900 text-cream-50" role="dialog" aria-modal="true" aria-labelledby="safety-heading" data-testid="safety-message">
      <div className="mx-auto flex min-h-full max-w-2xl flex-col justify-center px-6 py-12">
        <h1 id="safety-heading" className="text-4xl sm:text-5xl text-cream-50">{block?.title || "Thank You For Telling Us"}</h1>
        <p className="mt-6 text-lg leading-relaxed">{block?.body || FALLBACK}</p>
        <ul className="mt-10 space-y-4" data-testid="safety-lines">
          {lines.map((l) => (
            <li key={l.name} className="border border-cream-50/30 p-4">
              <p className="font-serif text-xl font-semibold">{l.name}</p>
              <div className="mt-3 flex flex-wrap gap-3">
                {l.href && <a href={l.href} className="btn-on-olive" data-testid={`safety-call-${l.call.replace(/\D/g, "")}`}>Call {l.call}</a>}
                {l.sms && <a href={l.sms} className="btn-outline-on-olive">{l.text || "Text"}</a>}
                {!l.sms && l.text && <span className="btn-outline-on-olive cursor-default">{l.text}</span>}
              </div>
            </li>
          ))}
        </ul>
        <button ref={btn} type="button" onClick={onDismiss} className="btn-on-olive mt-12 w-full sm:w-auto" data-testid="safety-dismiss">I've Read This</button>
      </div>
    </div>
  );
};
